import {JournalStats} from './JournalStats';
export default JournalStats;
